import AppErrorBoundary from './AppErrorBoundary';

export default AppErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/AppErrorBoundary/index.tsx